import { typography } from '../../../theme/tokens/typography';

/** Apex-style sidebar type scale. */
export function createSidebarTypography(sidebar) {
  const font = {
    fontFamily: typography.fontFamilyBase,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility',
    fontFeatureSettings: '"cv02", "cv03", "cv04", "cv11"',
  };

  return {
    root: font,
    brandTitle: {
      ...font,
      fontSize: '0.9375rem',
      fontWeight: typography.fontWeightBold,
      lineHeight: typography.lineHeightTight,
      letterSpacing: '-0.02em',
      color: sidebar.text,
    },
    brandSubtitle: {
      ...font,
      fontSize: '10px',
      fontWeight: typography.fontWeightMedium,
      lineHeight: typography.lineHeightTight,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: sidebar.textMuted,
    },
    sectionLabel: {
      ...font,
      fontSize: '11px',
      fontWeight: typography.fontWeightSemibold,
      lineHeight: typography.lineHeightTight,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: sidebar.textSection,
    },
    navLabel: (active = false) => ({
      ...font,
      fontSize: typography.fontSizeMd,
      fontWeight: active ? typography.fontWeightMedium : typography.fontWeightRegular,
      lineHeight: typography.lineHeightTight,
      letterSpacing: '-0.006em',
      color: active ? sidebar.text : sidebar.textNav,
    }),
    navLabelNested: (active = false) => ({
      ...font,
      fontSize: typography.fontSizeSm,
      fontWeight: active ? typography.fontWeightMedium : typography.fontWeightRegular,
      lineHeight: typography.lineHeightTight,
      letterSpacing: '-0.004em',
      color: active ? sidebar.text : sidebar.textNav,
    }),
    badge: {
      ...font,
      fontSize: '11px',
      fontWeight: typography.fontWeightSemibold,
      lineHeight: 1,
    },
    userName: {
      ...font,
      fontSize: typography.fontSizeSm,
      fontWeight: typography.fontWeightSemibold,
      lineHeight: typography.lineHeightTight,
      letterSpacing: '-0.01em',
      color: sidebar.text,
    },
    userRole: {
      ...font,
      fontSize: typography.fontSizeXs,
      fontWeight: typography.fontWeightRegular,
      lineHeight: typography.lineHeightTight,
      color: sidebar.textMuted,
    },
    avatarInitials: {
      ...font,
      fontSize: typography.fontSizeSm,
      fontWeight: typography.fontWeightSemibold,
      letterSpacing: '0.02em',
    },
    tooltip: {
      ...font,
      fontSize: typography.fontSizeSm,
      fontWeight: typography.fontWeightMedium,
      lineHeight: typography.lineHeightTight,
      letterSpacing: '-0.01em',
      px: 1.25,
      py: 0.75,
      borderRadius: '6px',
    },
  };
}
